export interface IApiVideoFile {
  VideoID?: number;
  VideoUrl?: string;
  HSLVideoUrl?: string;
  ThumbUrl?: string;
  Duration?: number;
  ContentType?: string;
}

export interface IVideoFile {
  videoId: number;
  videoUrl: string;
  hSLVideoUrl: string;
  thumbUrl: string;
  duration: number;
  contentType: string;
}

export const mappingVideoFile = (raw: IApiVideoFile): IVideoFile => {
  return {
    videoId: raw?.VideoID || 0,
    videoUrl: raw?.VideoUrl || '',
    hSLVideoUrl: raw?.HSLVideoUrl || '',
    thumbUrl: raw?.ThumbUrl || '',
    duration: raw?.Duration || 0,
    contentType: raw?.ContentType || '',
  };
};
